<template>
    <div>
        <Breadcrumbs main="Contact Center Portal" title="Email Priority" />
        <div class="container-fluid">
            <div class="d-flex justify-content-end m-3">
                <b-button
                    v-if="!edit"
                    variant="warning"
                    class="text-dark btn-pill"
                    @click="(edit=!edit)"
                >
                    <i class="icofont icofont-ui-edit"></i> Edit</b-button
                >
                <b-button
                    v-if="edit"
                    variant="success"
                    class="btn-pill"
                    @click="confirmAlertNumber('Confirm to update number ?', 'update number')"
                >
                    <i class="fa fa-check"></i> Complete</b-button
                >
                <b-button
                    v-if="edit"
                    variant="danger"
                    class="btn-pill"
                    @click="edit = !edit"
                >
                <i class="fa fa-check"></i> Cancel</b-button
                >
            </div>
            
            <div class="row">
                <div class="col-4">
                    <div class="card p-4">
                        <div class="card-header-right-icon text-right mt-2 mb-2" v-if="edit">
                            <b-button variant="primary" class="btn btn-pill" @click="openModal1('Add')">
                                <i class="icofont icofont-plus-circle"></i> Add Priority
                            </b-button>
                        </div>
                        <div class="card p-4"  v-for="n,index in priorityList" :key="index">
                            <label class="mb-2">Level {{n.no}}</label>
                            <draggable class="list-group" :disabled="!edit" v-model="n.mailList" group="people" disable>
                                <div
                                    class="list-group-item"
                                    v-for="(element,j) in n.mailList"
                                    :key="j"
                                >
                                    {{element.email}}
                                </div>
                            </draggable>
                        </div>
                    </div>
                </div>
                <div class="col-8">
                    <div class="card p-2" style="height: 70vh; overflow-y: scroll">
                        <div class="card-header" style="padding:20px">
                            <div class="header-top">
                                <h4 class="m-0">Add E-mail</h4>
                                <div class="card-header-right-icon">
                                    <b-button variant="primary" class="btn btn-pill" @click="openModal('Add')">
                                        <i class="icofont icofont-plus-circle"></i> Add E-mail
                                    </b-button>
                                </div>
                            </div>
                        </div>
                        <div class="p-2">
                            <table class="table table border">
                                <thead>
                                    <tr>
                                        <th width="90%" class="h6">Email</th>
                                        <th width="10%" class="h6">Active</th>
                                    </tr>
                                </thead>
                                <draggable v-model="rows" :disabled="!edit" group="people"  tag="tbody">
                                    <tr v-for="(item, j) in rows" :key="j" class="row-table" style="cursor: all-scroll">
                                        <td scope="row" width="90%">{{ item.email }}</td>
                                        <td scope="row" width="10%">
                                            <b-dropdown
                                                variant="black"
                                                toggle-class="text-decoration-none p-0 "
                                                no-caret
                                            >
                                                <template #button-content>
                                                    <i class="icon-more-alt rounded-circle p-2 action"></i>
                                                </template>
                                                <b-dropdown-item  @click="openModal('View',item)">View </b-dropdown-item>
                                                <b-dropdown-item  @click="openModal('Edit',item)">Edit</b-dropdown-item>
                                                <b-dropdown-item  @click="openModal('Delete',item)">Delete</b-dropdown-item>
                                            </b-dropdown>
                                        </td>
                                    </tr>
                                </draggable>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <ValidationObserver v-slot="{ invalid }">
            <b-modal
                :hide-footer="modalData.title == 'View'"
                content-class="rounded-1"
                v-model="showModal"
                body-class="p-4"
                centered
                :title="`${modalData.title} E-mail`"
            >
                <div class="row">
                    <div v-for="(form, i) in form" :key="i" :class="`col-${form.col}`">
                        <ValidationProvider
                            :name="form.name"
                            :rules="form.validate ? form.rule: null"
                            v-slot="{ errors, ariaMsg }"
                        >
                            <b-form-group :label="form.name" :label-for="form.name">
                                <template #description>
                                    <span class="text-danger" v-bind="ariaMsg" v-if="errors[0]">{{ errors[0] }}</span>
                                </template>
                                <b-form-input
                                    v-if="form.type=='input'"
                                    :placeholder="form.placeholder"
                                    :disabled="modalData.disable"
                                    v-model="form.value"
                                    :id="form.name"
                                ></b-form-input>
                                <b-form-input
                                    v-else-if="form.type=='email'"
                                    type="email"
                                    :placeholder="form.placeholder"
                                    :disabled="modalData.disable"
                                    v-model="form.value"
                                    :id="form.name"
                                ></b-form-input>
                            </b-form-group>
                            
                        </ValidationProvider>
                    </div>
                </div>
                <template #modal-footer>
                    <b-button variant="primary" :disabled="invalid" @click="confirmAlert(modalData)"><i class="fa fa-save"></i> Save</b-button>
                </template>
            </b-modal>
            <b-modal
                :hide-footer="modalData1.title == 'View'"
                content-class="rounded-1"
                v-model="showModalPriority"
                body-class="p-4"
                centered
                :title="`${modalData1.title} Priority`"
            >
                <div class="row">
                    <div v-for="(form, i) in form1" :key="i" :class="`col-${form.col}`">
                        <ValidationProvider
                            :name="form.name"
                            :rules="form.validate ? form.rule: null"
                            v-slot="{ errors, ariaMsg }"
                        >
                            <b-form-group :label="form.name" :label-for="form.name">
                                <template #description>
                                    <span class="text-danger" v-bind="ariaMsg" v-if="errors[0]">{{ errors[0] }}</span>
                                </template>
                                <b-form-input
                                    v-if="form.type=='input'"
                                    :placeholder="form.placeholder"
                                    :disabled="modalData.disable"
                                    v-model="form.value"
                                    :id="form.name"
                                ></b-form-input>
                                <b-form-input
                                    v-else-if="form.type=='number'"
                                    type="number"
                                    :placeholder="form.placeholder"
                                    :disabled="modalData.disable"
                                    v-model="form.value"
                                    :id="form.name"
                                ></b-form-input>
                            </b-form-group>
                            
                        </ValidationProvider>
                    </div>
                </div>
                <template #modal-footer>
                    <b-button variant="primary" :disabled="invalid" @click="addPriority()"><i class="fa fa-save"></i> Save</b-button>
                </template>
            </b-modal>
        </ValidationObserver>
    </div>
</template>
<script>
    import { requestService } from './../../_services';
    export default {
        components: {},
        data() {
            return {
                modalData: {
                    title: null,
                    disable: false,
                    row: null,
                },
                modalData1: {
                    title: null,
                    disable: false,
                    row: null,
                },
                form: [
                    {
                        value: '',
                        col: 12,
                        name: 'Email',
                        type: 'input',
                        validate: true,
                        rule:"required",
                        placeholder:"Email",
                        vid:false,
                        disabled:true
                    },
                ],
                form1: [
                    {
                        value: '',
                        col: 12,
                        name: 'Priority No.',
                        type: 'number',
                        validate: true,
                        rule:"required|min_value:1|max_value:999",
                        placeholder:"no",
                        disabled:true
                    },
                ],
                rows: [],
                columns: [
                    {
                        label: 'Name',
                        field: 'name',
                        hidden: false,
                    },
                    {
                        label: 'Action',
                        field: 'action',
                        thClass: 'custom-th-class',
                        hidden: false,
                    },
                ],
                priorityList:[],
                priorityObj:{},
                showModal:false,
                showModalPriority:false,
                edit:false
            };
        },
        async created() {
            await this.loadItems();
        },
        methods: {
            openModal(value, data) {
                this.modalData.title = value;
                switch(value) {
                    case "Add":
                        this.form[0].value ="";
                        this.modalData.disable = false
                        break;
                    case "View":
                        this.form[0].value =data.email;
                        this.modalData.disable = true
                        break;
                    case "Edit":
                        this.form[0].value =data.email;
                        this.modalData.disable = false
                        this.modalData.row = data;
                        break;
                    case "Delete":
                        this.modalData.row = data;
                        this.confirmAlert()
                        return
                    default:
                        break;
                        // code block
                }
                this.showModal = true;
            },
            openModal1(value, data) {
                this.modalData1.title = value;
                switch(value) {
                    case "Add":
                        this.form1[0].value ="";
                        this.modalData1.disable = false
                        break;
                    default:
                        break;
                        // code block
                }
                this.showModalPriority = true;
            },
            async confirmAlert(){
                this.$swal.fire({
                    title: `Confirm to ${this.modalData.title} E-mail ?`,
                    showDenyButton: true,
                    confirmButtonText: 'Yes',
                    denyButtonText: `No`,
                    icon: 'question',
                }).then((result) => {
                    if (result.isConfirmed) {
                        switch(this.modalData.title) {
                            case "Add":
                                this.onCreate()
                                break;
                            case "Edit":
                                this.onUpdate(this.modalData.row._id)
                                break;
                            case "Delete":
                                this.onDelete(this.modalData.row._id)
                                break;
                            default:
                                break;
                                // code block
                        }
                    }
                });
            },
            confirmAlertNumber(title, type) {
                this.$swal.fire({
                    title: title,
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#2971FF',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Ok',
                    camcelButtonText: 'Cancel',
                })
                .then((result) => {
                    if (result.isConfirmed) {
                    switch (type) {
                        case 'update number':
                            this.onUpdateNumber();
                        break;
                    }
                    }
                });
            },
            onUpdateNumber() {
                let payload=[]
                this.priorityList.forEach(element => {
                    element.mailList.forEach(item => {
                        let obj={
                            id:item._id,
                            email:item.email,
                            no:parseInt(element.no)
                        }
                        payload.push(obj)
                    });
                });
                this.rows.forEach(element => {
                    let obj={
                        id:element._id,
                        email:element.email,
                        no:0
                    }
                    payload.push(obj)
                });
                
                const url = `/api/mail/priority/convert/number`;
                requestService.PostFetch('ccp', url, payload).then(() => {
                    this.$swal.fire({
                        icon: 'success',
                        title: 'Priority has been saved',
                        showConfirmButton: false,
                        timer: 1500,
                    });
                    this.edit = !this.edit;
                }).catch((err) => {
                    this.$swal.fire({
                        icon: 'error',
                        title: 'Try Again',
                        text: err,
                        filterParam: '',
                    });
                });
            },
            async onCreate() {
                this.showModal = !this.showModal;
                const url = `/api/mail/priority`;
                const object = {
                    email: this.form[0].value,
                };
                return requestService.PostFetch('ccp', url, object).then((response) => {
                    if (response.status == 200) {
                        let self = this;
                        response.text().then((text) => {
                            const data = text && JSON.parse(text);
                            this.$swal.fire({
                                icon: 'success',
                                title: 'Email has been create',
                                showConfirmButton: false,
                                timer: 1500,
                            });
                            let obj={
                                _id:data.id,
                                email:this.form[0].value,
                                no:0
                            }
                            self.rows.push(obj)
                            self.showModal = false;
                        });
                    }
                }).catch((err) => {
                    this.$swal.fire({
                        icon: 'error',
                        title: 'Try Again',
                        text: err,
                    });
                });
            },
            async onUpdate(id) {
                this.showModal = !this.showModal;
                const url = `/api/mail/priority/${id}`;
                const object = {
                    email: this.form[0].value,
                };
                return requestService.PostFetch('ccp', url, object).then(() => {
                    this.$swal.fire({
                        icon: 'success',
                        title: 'Priority has been update',
                        showConfirmButton: false,
                        timer: 1500,
                    });
                    this.rows.forEach(element => {
                        if(element._id ==id){
                            element.email=this.form[0].value
                            return
                        }
                    });
                    this.showModal = false;
                }).catch((err) => {
                    this.$swal.fire({
                        icon: 'error',
                        title: 'Try Again',
                        text: err,
                    });
                });
            },
            async onDelete(id) {
                const url = `/api/mail/priority/${id}`;
                const object = {};
                return requestService.DeleteFetch('ccp', url, object).then(() => {
                    this.$swal.fire({
                        icon: 'success',
                        title: 'Email has been delete',
                        showConfirmButton: false,
                        timer: 1500,
                    });
                    var i=0
                    this.rows.forEach(function (element, index) {
                        if(element._id ==id){
                            i=index
                            return
                        }
                    });
                    this.rows.splice(i, 1);
                    
                    this.showModal = false;
                }).catch((err) => {
                    this.$swal.fire({
                        icon: 'error',
                        title: 'Try Again',
                        text: err,
                    });
                });
            },
            addPriority(){
                let filter=this.priorityList.filter(item => { 
                    if(item.no == this.form1[0].value){
                        return item;
                    } 
                });
                if(filter.length >0){
                    this.$swal.fire({
                        icon: 'error',
                        title: 'Try Again',
                        text: "Priority number has already exists",
                    });
                    return
                }
                let obj={
                    no:this.form1[0].value,
                    mailList:[]
                }
                this.priorityList.push(obj)
                this.priorityList.sort((a, b) => a.no - b.no);
                this.form1[0].value ="";
                this.showModalPriority = false;
            },
            async loadItems(event) {
                var url = '/api/mail/priority/filter'
                return requestService.GetFetch('ccp', url).then((response) => {
                    if (response.status == 200) {
                        response.text().then((text) => {
                            let self = this;
                            self.rows = [];
                            const data = text && JSON.parse(text);
                            if (data.data != null) {
                                data.data.forEach(element => {
                                    if(element.no >0 && element.no !=null && element.no != undefined){
                                        if(self.priorityObj[element.no] !=null &&self.priorityObj[element.no] !=undefined){
                                            let mailList=self.priorityObj[element.no].mailList
                                            mailList.push(element)
                                            self.priorityObj[element.no].mailList=mailList
                                        }else{
                                            let mailList=[]
                                            mailList.push(element)
                                            let obj={
                                                no:element.no,
                                                mailList:mailList
                                            }
                                            self.priorityObj[element.no]=obj
                                        }
                                    }else{
                                        self.rows.push(element)
                                    }
                                });
                                for (const [key, value] of Object.entries(self.priorityObj)) {
                                    let obj={
                                        no:self.priorityObj[key].no,
                                        mailList:self.priorityObj[key].mailList
                                    }
                                    self.priorityList.push(obj)
                                    self.priorityList.sort((a, b) => a.no - b.no);
                                }
                            } 
                        });
                    }
                });
            },
        },
    };
</script>